import { intersect, partial, struct } from 'io-ts/Decoder';

import { Id as JobId } from '../../../../job/Id';
import { Id as StageId } from '../../../../job/stage/Id';

export const Params = intersect(
	struct({
		jobId: JobId,
	})
)(
	partial({
		stageId: StageId,
	})
);
